 <template>
    <div>
        <el-input
            v-if="showInput"
            v-model="select.inputValue"
            @focus="Open"
            @clear="SelectClear"
            placeholder="回访记录"
            clearable
            :disabled="disabled"
            :style="{ width: width, margin: margin }"/>
        <el-dialog :visible.sync="dialogVisible" width="900px" append-to-body title="回访记录" :close-on-click-modal="false" :close-on-press-escape="false">
            <uw-grid-search gutter="0 10px" :column="3" :style="{ marginBottom: '10px' }">
                <template slot="full">
                    <crm-customer-select v-model="post.search.customer_id"  @onChange="TableSearch" />
                </template>
                <template slot="tools">
                    <el-button type="primary" @click="$refs.visitCreate.Open()">新建回访</el-button>
                </template>
                <el-form-item label="回访形式">
                    <crm-visit-type-select v-model="post.search.type_id" @onChange="TableSearch" />
                </el-form-item>
                <el-form-item label="回访人">
                    <users-select @onChange="TableSearch" v-model="post.search.user_admin_ids" multiple />
                </el-form-item>
                <el-form-item label="回访时间">
                    <el-date-picker @change="TableSearch" v-model="post.search.date" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :style="{ width: '100%' }"></el-date-picker>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker @change="TableSearch" v-model="post.search.created_at" clearable type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :style="{ width: '100%' }"></el-date-picker>
                </el-form-item>
            </uw-grid-search>
            <vxe-table ref="xTable" :data="table" :loading="$store.state.loading" @sort-change="TableSort" @cell-dblclick="TableCellDblclick" height="500px">
                <vxe-column width="60" type="seq" title="序号" fixed="left"></vxe-column>
                <vxe-column min-width="160" field="number" title="回访编号" fixed="left" sortable>
                    <template #default="{ row }">
                        <el-link type="primary" icon="el-icon-paperclip" @click="$refs.visitDrawer.Open(row.id)">{{ row.number }}</el-link>
                    </template>
                </vxe-column>
                <vxe-column min-width="100" field="date" title="回访时间"></vxe-column>
                <vxe-column min-width="120" field="type" title="回访形式" sortable>
                    <template #default="{ row }">
                        <el-link :underline="false">{{ row.type?.name }}</el-link>
                    </template>
                </vxe-column>
                <vxe-column min-width="160" field="customer" title="客户名称" sortable>
                    <template #default="{ row }">
                        <el-link :underline="false" type="primary" @click="$refs.customerDrawer.Open(row.customer?.id)">{{ row.customer?.name }}</el-link>
                    </template>
                </vxe-column>
                <vxe-column min-width="120" field="contacts" title="联系人" sortable>
                    <template #default="{ row }">
                        <el-link :underline="false" type="primary" @click="$refs.contactsDrawer.Open(row.contacts?.id)">{{ row.contacts?.name }}</el-link>
                    </template>
                </vxe-column>
                <vxe-column min-width="250" field="contract" title="合同编号" sortable>
                    <template #default="{ row }">
                        <el-link :underline="false" type="primary" @click="$refs.contractDrawer.Open(row.contract?.id)">{{ row.contract?.number + '-' }}{{ row.contract?.name }}</el-link>
                    </template>
                </vxe-column>
                <vxe-column min-width="120" field="satisficing" title="客户满意度" sortable>
                    <template #default="{ row }">
                        <el-link :underline="false">{{ row.satisficing?.name }}</el-link>
                    </template>
                </vxe-column>
                <vxe-column min-width="160" field="remarks" title="客户反馈"></vxe-column>
                <vxe-column min-width="90" field="user_admin" title="回访人">
                    <template #default="{ row }">
                        <el-link :underline="false" icon="el-icon-user" v-if="row.user_admin">{{ row.user_admin?.name }}</el-link>
                    </template>
                </vxe-column>
            </vxe-table>
            <vxe-pager 
                :style="{ marginTop: '10px' }"
                :total="post.page.total"
                :page-size.sync="post.page.size"
                :current-page.sync="post.page.current"
                @page-change="TableSearch()">
            </vxe-pager>
        </el-dialog>
        <crm-visit-create ref="visitCreate" @onChange="TableSearch()" />
        <crm-contract-drawer ref="contractDrawer" @onChange="TableSearch()" />
        <crm-contacts-drawer ref="contactsDrawer" @onChange="TableSearch()" />
        <crm-customer-drawer ref="customerDrawer" @onChange="TableSearch()" />
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Array, Number],
            default: null
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showInput: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            dialogVisible: false,
                        table: [],
                        url: {
                default: '/9api/crm/visit/search',
                first: '/9api/crm/visit/first'
            },
                        post: {
                page: {
                    total: 0,
                    size: 50,
                    current: 1,
                },
                search: {
                    customer_id: null,
                    type_id: null,
                    user_admin_ids: null,
                    date: null,
                    created_at: null
                },
                append: ['user_admin', 'type', 'contract', 'customer', 'contacts', 'satisficing'],
                hidden: [],
                order: {
                    method: 'desc',
                    column: 'id'
                },
            },
                        select: {
                data: {},
                inputValue: null
            }
        }
    },
    watch: {
        value: {
            handler(val) {
                val ? this.SelectSearch() : this.SelectClear()
            },
            immediate: true
        }
    },
    methods: {
                Open(search)
        {
                        if (search)
            {
                this.post.search = { ...this.post.search, ...search }
            }
            this.dialogVisible = true
            this.TableSearch()
        },
                TableSearch()
        {
            this.$http.post(this.url.default, this.post).then((rps) => {
                                this.post.page.total = rps.data.total
                this.table = rps.data.body
                                if (this.table.length == 0 && this.post.page.current != 1)
                {
                    this.post.page.current = 1
                    this.TableSearch()
                }
            })
        },
                TableSort(column)
        {
            this.post.order.method = column.order ? column.order : this.post.order.method
            this.post.order.column = column.field
            this.TableSearch()
        },
                TableCellDblclick({ row })
        {
            this.select.inputValue = row.name
            this.select.data = row
            this.$emit('input', row.id)
            this.$emit('onChange', row)
            this.dialogVisible = false
        },
                SelectSearch()
        {
            this.$http.post(this.url.first, { id: this.value }).then(rps => {
                this.select.inputValue = rps.data.name
                this.select.data = rps.data
                this.$emit('input', rps.data.id)
                this.$emit('onChange', rps.data)
            })
        },
                SelectClear()
        {
            this.select.inputValue = null
            this.select.data = {}
            this.$emit('input', null)
            this.$emit('onChange', null)
        },
    }
}
</script>